import React from 'react';

function WelcomeScreenIcon(props) {
  let icon;
  switch (props.variant) {
    case 'cash':
      icon = (
        <svg
          width="35"
          height="34"
          viewBox="0 0 35 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2.90039"
            y="1"
            width="27.8259"
            height="7.99998"
            rx="1"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.9893 1V8.99998"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.85156 1V8.99998"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.7656 1V8.99998"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.6387 1V8.99998"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="1.5"
            y="9"
            width="27.8259"
            height="7.99998"
            rx="1"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5889 9V17"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.45117 9V17"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.3652 9V17"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.2383 9V17"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="2.90039"
            y="17"
            width="27.8259"
            height="7.99998"
            rx="1"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.9893 17V25"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.85156 17V25"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.7656 17V25"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.6387 17V25"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="5.67383"
            y="25"
            width="27.8259"
            height="7.99998"
            rx="1"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.7627 25V33"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.625 25V33"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5391 25V33"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.4121 25V33"
            stroke="#0AFF98"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'mtt':
      icon = (
        <svg
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.53376 5.41504H0.543617C0.543617 5.41504 -0.926829 17.9085 13.2078 17.9085"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.7769 5.41504H32.4518C32.4518 5.41504 33.9457 17.9085 20.2314 17.9085"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.7745 29.387V28.3548C10.7745 27.1323 12.5731 27.0838 13.5069 26.8064C14.5578 24.2258 14.768 22.729 14.6103 20.6129C13.9798 20.6129 13.5069 20.1484 13.5069 19.529V17.929C7.67436 15.4516 6.46582 6.36773 6.46582 1H26.9584C26.9584 6.41935 25.7499 15.5032 19.9174 17.929V19.529C19.9174 20.1484 19.3919 20.6129 18.8139 20.6129C18.6563 22.729 18.8139 24.2774 19.8648 26.8064C20.6107 26.9768 23.2277 27.0556 23.2277 28.3548V29.387"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.8049 4.75879C10.8049 4.75879 11.5407 10.5425 14.0858 13.4892"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.1805 29.3872H24.3857C24.9637 29.3872 26.435 31.9678 26.435 31.9678C26.435 32.5356 25.9621 33.0001 25.4366 33.0001H8.56965C7.99165 33.0001 7.57129 32.5356 7.57129 31.9678C7.57129 31.9678 9.04255 29.3872 9.62055 29.3872H12.8258"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'createClub':
      icon = (
        <svg
          width="31"
          height="24"
          viewBox="0 0 31 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4967 4.1248C16.3666 4.1248 17.0718 3.41961 17.0718 2.54971C17.0718 1.6798 16.3666 0.974609 15.4967 0.974609C14.6268 0.974609 13.9216 1.6798 13.9216 2.54971C13.9216 3.41961 14.6268 4.1248 15.4967 4.1248ZM6.57446 4.12512C6.57446 4.70506 6.10433 5.17519 5.5244 5.17519C4.94446 5.17519 4.47433 4.70506 4.47433 4.12512C4.47433 3.54519 4.94446 3.07506 5.5244 3.07506C6.10433 3.07506 6.57446 3.54519 6.57446 4.12512ZM3.97433 12.0001C3.97433 7.95442 7.25403 4.67472 11.2997 4.67472H19.7003C23.746 4.67472 27.0257 7.95442 27.0257 12.0001C27.0257 16.0458 23.746 19.3256 19.7003 19.3256H11.2998C7.25404 19.3256 3.97433 16.0458 3.97433 12.0001ZM11.2997 5.67472C7.80632 5.67472 4.97433 8.5067 4.97433 12.0001C4.97433 15.4936 7.80632 18.3256 11.2998 18.3256H19.7003C23.1937 18.3256 26.0257 15.4936 26.0257 12.0001C26.0257 8.5067 23.1937 5.67472 19.7003 5.67472H11.2997ZM5.5244 20.9255C6.10433 20.9255 6.57446 20.4553 6.57446 19.8754C6.57446 19.2955 6.10433 18.8253 5.5244 18.8253C4.94446 18.8253 4.47433 19.2955 4.47433 19.8754C4.47433 20.4553 4.94446 20.9255 5.5244 20.9255ZM2.37357 12.0003C2.37357 12.5802 1.90344 13.0503 1.3235 13.0503C0.743567 13.0503 0.273438 12.5802 0.273438 12.0003C0.273438 11.4203 0.743567 10.9502 1.3235 10.9502C1.90344 10.9502 2.37357 11.4203 2.37357 12.0003ZM17.0718 21.4506C17.0718 22.3205 16.3666 23.0257 15.4967 23.0257C14.6268 23.0257 13.9216 22.3205 13.9216 21.4506C13.9216 20.5807 14.6268 19.8755 15.4967 19.8755C16.3666 19.8755 17.0718 20.5807 17.0718 21.4506ZM26.5219 5.17519C27.1019 5.17519 27.572 4.70506 27.572 4.12512C27.572 3.54519 27.1019 3.07506 26.5219 3.07506C25.942 3.07506 25.4719 3.54519 25.4719 4.12512C25.4719 4.70506 25.942 5.17519 26.5219 5.17519ZM27.572 19.8754C27.572 20.4553 27.1019 20.9255 26.5219 20.9255C25.942 20.9255 25.4719 20.4553 25.4719 19.8754C25.4719 19.2955 25.942 18.8253 26.5219 18.8253C27.1019 18.8253 27.572 19.2955 27.572 19.8754ZM29.6774 13.0503C30.2573 13.0503 30.7274 12.5802 30.7274 12.0003C30.7274 11.4203 30.2573 10.9502 29.6774 10.9502C29.0974 10.9502 28.6273 11.4203 28.6273 12.0003C28.6273 12.5802 29.0974 13.0503 29.6774 13.0503Z"
            fill="#00FFB2"
          />
        </svg>
      );
      break;
    case 'joinClub':
      icon = (
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.7285 8.83062C26.0008 8.83062 27.8428 6.98859 27.8428 4.71634C27.8428 2.44408 26.0008 0.602051 23.7285 0.602051C21.4563 0.602051 19.6143 2.44408 19.6143 4.71634C19.6143 6.98859 21.4563 8.83062 23.7285 8.83062Z"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.8996 19.1169V17.0597C29.8996 13.6513 27.1366 10.8882 23.7282 10.8882C21.4039 10.8882 19.3797 12.173 18.3271 14.0711"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.27151 8.83062C9.54377 8.83062 11.3858 6.98859 11.3858 4.71634C11.3858 2.44408 9.54377 0.602051 7.27151 0.602051C4.99926 0.602051 3.15723 2.44408 3.15723 4.71634C3.15723 6.98859 4.99926 8.83062 7.27151 8.83062Z"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.09961 19.1169V17.0597C1.09961 13.6513 3.86272 10.8882 7.27117 10.8882C9.5954 10.8882 11.6195 12.173 12.6721 14.0711"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.502 21.169C17.7742 21.169 19.6163 19.327 19.6163 17.0547C19.6163 14.7825 17.7742 12.9404 15.502 12.9404C13.2297 12.9404 11.3877 14.7825 11.3877 17.0547C11.3877 19.327 13.2297 21.169 15.502 21.169Z"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.6742 29.397C21.6742 25.9886 18.9111 23.2256 15.5026 23.2256C12.0941 23.2256 9.33105 25.9886 9.33105 29.397"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'gameLobby':
      icon = (
        <svg
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="16.5004"
            cy="16.9999"
            r="9.6"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.5 16.9999L16.5 11.3999L20.5 16.9999L16.5 22.5999L12.5 16.9999Z"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="16.5"
            cy="17"
            r="16"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.7 7.3998L20.5 1.7998M13.3 7.3998L12.5 1.7998"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.8998 13.8L1.2998 13M6.8998 20.2L1.2998 21"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.38083 21.3869L2.80411 24.7116M11.8368 25.9809L8.37402 30.4541"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.6201 21.3869L30.1969 24.7116M21.1642 25.9809L24.627 30.4541"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.5 32.2001L19.7 26.6001M12.5 32.2001L13.3 26.6001"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.6996 13L26.0996 13.8M31.6996 21L26.0996 20.2"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.6266 3.54608L21.1638 8.01927M30.1965 9.28856L25.6198 12.6133"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.37538 3.54608L11.8381 8.01927M2.80546 9.28856L7.38219 12.6133"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'practice':
      icon = (
        <svg
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.085 10.4341C12.4999 11.6307 10.8879 13.0319 9.31627 14.6069C2.2931 21.6451 -1.26528 29.4904 1.36842 32.1298C4.00209 34.7689 11.8305 31.203 18.8537 24.1648C20.4254 22.5898 21.8235 20.9743 23.0176 19.3858"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.0176 19.3856C27.1595 24.8954 28.846 30.0807 26.8016 32.1295C24.1678 34.7689 16.3394 31.2027 9.31627 24.1645C2.2931 17.1263 -1.26528 9.28109 1.36842 6.64176C3.41273 4.59306 8.58695 6.28317 14.085 10.4339"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.8496 19.3856C12.8496 20.0691 13.4025 20.6232 14.0846 20.6232C14.7667 20.6232 15.3196 20.0691 15.3196 19.3856C15.3196 18.702 14.7667 18.1479 14.0846 18.1479C13.4025 18.1479 12.8496 18.702 12.8496 19.3856Z"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.0477 8.60875C18.2718 8.47347 18.2718 7.35724 19.0477 7.22197C21.8587 6.73188 24.0944 4.58625 24.7045 1.79306L24.7514 1.57896C24.9191 0.810462 26.0111 0.80568 26.1857 1.57267L26.2426 1.82219C26.8751 4.60219 29.1115 6.7297 31.9147 7.21843C32.6947 7.35439 32.6947 8.47632 31.9147 8.61229C29.1115 9.10101 26.8751 11.2286 26.2426 14.0086L26.1857 14.2581C26.0111 15.0251 24.9191 15.0203 24.7514 14.2518L24.7045 14.0377C24.0944 11.2445 21.8587 9.09883 19.0477 8.60875Z"
            stroke="#00FFB2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
  }
  return icon;
}

export default WelcomeScreenIcon;
